import notification from "antd/lib/notification";
import Modal from "antd/lib/modal";
import React, { useState } from "react";
import dayjs from "dayjs";
import { ProcessAppointment } from "../services/AppointmentsService";
import { getImageBaseUrl } from "../services/s3-utils";
import { myTimeZone } from "../utils/reshapData";
import { convertTimeToMMHH, getDateTimeDate } from "../utils/timeHelpers";

function Request({ request, fetchData }) {
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const isDefault =
    request.host_user.profile && !request.host_user.profile.includes("default");
  const imageUrl = isDefault
    ? request.host_user.profile
    : `${getImageBaseUrl}/assets/avatar.svg`;

  const processRequest = async (response) => {
    let payload = {
      id: request.id,
      response,
    };
    setLoading(true);
    ProcessAppointment(payload, request.id)
      .then((res) => {
        notification.success({
          message: "Appointment updated successfully",
        });
        fetchData();
        setVisible(false);
      })
      .catch((err) => {
        notification.error({
          message:
            err.response?.data?.message || "An error occured. Please try again",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <>
      <div
        className="flex pb-2 mb-0"
        style={{
          borderBottom: "1px solid #DCDCE9",
        }}
        onClick={() => setVisible(true)}
      >
        <img src={imageUrl} alt="" className="rounded-full w-10 h-10 mr-3" />
        <div className="mr-3">
          {request.host_user.first_name} {request.host_user.last_name} has
          requested to book an appointment with you
        </div>
      </div>

      <Modal
        visible={visible}
        onCancel={() => setVisible(null)}
        title={<p className="text-xl text-dark mb-2">{request.title}</p>}
        footer={
          <div className="flex justify-between">
            <button
              data-testid="approve_btn"
              onClick={() => processRequest("accepted")}
              className="bg-pri text-white b-w-0  rounded-md px-4 py-3  h-[50px]"
            >
              {loading ? (
                <img
                  src={`${getImageBaseUrl}/assets/spinner.svg`}
                  alt=""
                  className="w-6"
                />
              ) : (
                "Approve"
              )}
            </button>
            <button
              data-testid="cencel_btn"
              onClick={() => processRequest("rejected")}
              className="bg-white border-slate-400  text-dark border-1  rounded-md px-4 h-[50px]"
            >
              {loading ? (
                <img
                  src={`${getImageBaseUrl}/assets/spinner.svg`}
                  className="w-6"
                  alt=""
                />
              ) : (
                "Decline"
              )}
            </button>
          </div>
        }
      >
        <div>
          <p data-testid="meeting_desc" className="text-sm text-tint">
            {request.description}
          </p>

          <p className="text-xl text-dark mb-2 mt-7">Guest</p>
          <div className="flex items-center">
            <img
              src={
                request.host_user.profile ||
                `${getImageBaseUrl}/assets/avatar.svg`
              }
              className="w-8 h-8 mr-2 rounded-full"
              alt=""
            />
            <span
              data-testid="meeting_partner"
              className="text-sm text-tint capitalize"
            >
              {request.host_user.first_name} {request.host_user.last_name}
            </span>
          </div>

          <p className="text-xl text-dark mb-2 mt-7">Date & Time</p>
          <div className="flex items-center py-2 text-tint">
            <img src={`${getImageBaseUrl}/assets/calendar.svg`} alt="" />
            <span className="ml-2">
              {dayjs(getDateTimeDate(request.start_date)).format(
                "ddd, DD MMM YYYY"
              )}
            </span>
          </div>
          <div className="flex items-center py-2 text-tint">
            <img src={`${getImageBaseUrl}/assets/clock.svg`} alt="" />
            <span className="ml-2">
              {convertTimeToMMHH(request.start_time)} -{" "}
              {convertTimeToMMHH(request.end_time)} ({myTimeZone})
            </span>
          </div>
        </div>
      </Modal>
    </>
  );
}

export default Request;
